export enum FilterFieldType {
  Datetime = 'DATETIME',
  Relation = 'RELATION',
  String = 'STRING',
  Uuid = 'UUID',
  Longtext = 'LONGTEXT'
}

export type FieldType = `${FilterFieldType}`
